import { AppData } from "@lightningjs/sdk";
import { AppSetup } from "./app-setup";
import { fetchData, getBookmarkingData } from "./models/data-service";
import { Helper } from "./helper";
import { ItemNode } from "./components/grid/ItemNode";
import Router from "@lightningjs/sdk/src/Router";
import { parseVideos } from "./parser";
import GridViewModel from "./components/grid/grid-view-model";


export type BookMarkData = {
    id: number
    bData:[any]
}

export default class BookmarkingManager {

  isUserInitiated = false

  bookMarkSection: BookMarkData[] = []

  checkBookmarkAndLoadShows = async (vodInfo:ItemNode) => {
    const { appConfig, appState } = AppData as AppSetup;
    if(!vodInfo.season || vodInfo.season == 'na') return null;
    let bdata:ItemNode[] = []
    try {
      const bdataResults  = await fetchData(getBookmarkingData(vodInfo))
      const bdata = parseVideos(bdataResults.data)

      if(bdata && bdata.length==1) {
        return null
      }
      let lsData:any
        let resTime:number
        if (appConfig?.useLocalStorage == true) {
          lsData = localStorage.getItem(bdata[1].node_id);
        } else {
          lsData = Helper.getCookie(bdata[1].node_id);
        }

        if (lsData) {
          resTime = parseInt(lsData);
        } else {
          resTime = 0;
        }

        return bdata
    } catch(e) {
      //this.loadShows(vodInfo);
      return null
    }
  }



  async loadMlp(_vodInfo:ItemNode, _episodeVodInfo:ItemNode) {
    const { appState } = AppData as AppSetup;
    const app = appState?.getApp();
    const grid:GridViewModel = (app?.loadShow(_vodInfo, _vodInfo.id))!
    await grid._init()
    grid.createGridListUI()
    //console.log('loadMlp: ',_episodeVodInfo.season, _episodeVodInfo.episode)
    await grid.findAndLoadSeasonEpisode(_episodeVodInfo.season, _episodeVodInfo.episode)
  }
}
